<template>
  <item-box class-suffix="radio">
    <el-form-item label="ID">
      <el-input v-model="data.fieldId" />
    </el-form-item>
    <el-form-item label="标签">
      <el-input v-model="data.label" />
    </el-form-item>
    <el-form-item label="选项">
      <div v-for="item in data.selections" :key="item.value" class="tpf-mf-setting-radio--radio">
        <el-radio v-model="data.value" :label="item.value">
          <span v-text="item.label" />
        </el-radio>
        <span class="tpf-mf-setting-radio--radio--delete"><i class="el-icon-delete" @click.stop="delRadio(item)" /></span>
        <span v-show="item.value === data.value" class="tpf-mf-setting-radio--radio--default-text">默认选择</span>
      </div>
      <div v-if="inputing" class="tpf-mf-setting-radio--add">
        <el-form :inline="true" :model="addForm" class="tpf-mf-setting-radio--add--form" :rules="rules">
          <el-form-item prop="label">
            <el-input v-model="addForm.label" size="mini" placeholder="请输入标签" />
          </el-form-item>
          <el-form-item prop="value">
            <el-input v-model="addForm.value" size="mini" placeholder="请输入值" />
          </el-form-item>
        </el-form>
        <el-button type="primary" icon="el-icon-check" size="mini" @click="add" />
        <el-button type="info" icon="el-icon-close" size="mini" @click="inputing=!inputing" />
      </div>
      <el-button v-else type="text" icon="el-icon-plus" size="mini" @click="inputing=!inputing;addForm.label='';addForm.value=''">添加一项</el-button>
    </el-form-item>
  </item-box>
</template>

<script>
import _ from 'lodash'
import ItemBox from '../common/ItemBox'
export default {
  name: 'RadioConfig',
  components: { ItemBox },
  mixins: [],
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      inputing: false,
      addForm: {
        label: '',
        value: ''
      },
      rules: {
        label: [{ required: true, message: '请输入标签', trigger: 'blur' }],
        value: [{ required: true, message: '请输入值', trigger: 'blur' }]
      }
    }
  },
  methods: {
    delRadio(item) {
      const i = this.data.selections.findIndex(s => s === item)
      this.data.selections.splice(i, 1)
      if (item.value === this.data.value) {
        this.data.value = ''
      }
    },
    add() {
      if (_.trim(this.addForm.label) !== '' && _.trim(this.addForm.value) !== '') {
        this.data.selections.push({ ...this.addForm })
        this.inputing = !this.inputing
      }
    }
  }
}
</script>
